<template>
  <div>
    <navbar></navbar>
    <div class="container mt-3">
      <div class="row">
        <div v-if="flashdata" class="offset-md-4 col-md-4">
          <b-alert :show="true" dismissible>
            Mensaje:
            <div v-html="flashdata"></div>
          </b-alert>
        </div>
        <div class="col-12">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from 'views/components/mm_pro/components/navbar.vue';
import { mapFields } from 'vuex-map-fields';
import { get_sesion_local_storage, guardar_sesion_local_storage, borrar_sesion_local_storage } from 'views/components/mm_pro/components/sesion.js';
import { empty } from 'views/components/php.js';

export default {
  components: {
    navbar
  },
  props: {
    sesion: {
      type: String,
      default: '{}'
    },
    flashdata: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapFields([
      'empresa'
    ])
  },
  beforeMount() {
    this.decodificar_sesion();
  },
  methods: {
    decodificar_sesion() {
      const session = JSON.parse(this.sesion);
      if (!empty(session) && session.id > 0) {
        guardar_sesion_local_storage(session);
      }

      const sesion_ls = get_sesion_local_storage();
      if (empty(sesion_ls)) {
        localStorage.removeItem('usuario');
      }

      if (this.$router.currentRoute.path !== '/login') {
        this.empresa = { ...this.empresa, ...sesion_ls };
      }
    }
  }
};
</script>
